var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center",style:({ height: '50vh' })},[_vm._v(" Login erfolgreich! Bitte warten... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }